var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Grid } from "react-bootstrap";
import React, { Component } from "react";
import { get } from "lodash";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import userService from "@irati/identity/services/users";
import Flex from "@irati/ui/src/Flex";
import Button from "@irati/ui/src/Button";
import { handleActivationStatusChange } from "@irati/identity/apollo/query/UsersForBusiness";
import { AreYouSurePopUp } from "../../AreYouSurePopUp/index";
import PopUp from "./styled/PopUp";
import H3 from "./styled/H3";
var ManageUsersBottomBar = /** @class */ (function (_super) {
    __extends(ManageUsersBottomBar, _super);
    function ManageUsersBottomBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: null
        };
        _this.openDeactivatePopUp = function () {
            _this.deactivatePopup.toggle();
        };
        _this.isDeactivatedList = function () {
            return !get(_this.props.selectedEmployees, "[0].isEnabled", false);
        };
        _this.areYouSureText = function () {
            var _a = _this.props, selectedEmployees = _a.selectedEmployees, formatMessage = _a.formatMessage;
            var activateThem = _this.isDeactivatedList();
            var name = selectedEmployees[0]
                ? selectedEmployees[0].firstName
                : formatMessage({ id: "admin.components.manageUsersPopUp.areYouSureText.thisUser" });
            var action = activateThem
                ? formatMessage({ id: "admin.components.manageUsersPopUp.areYouSureText.action.activate" })
                : formatMessage({ id: "admin.components.manageUsersPopUp.areYouSureText.action.deactivate" });
            var to = selectedEmployees.length > 1
                ? formatMessage({ id: "admin.components.manageUsersPopUp.areYouSureText.users" }, { selectedEmployeesLength: selectedEmployees.length })
                : name;
            return formatMessage({ id: "admin.components.manageUsersPopUp.areYouSureText.text" }, { action: action, to: to });
        };
        _this.handleSubmit = function () {
            var _a = _this.props, selectedEmployees = _a.selectedEmployees, onSave = _a.onSave;
            var isDeactivatedList = _this.isDeactivatedList();
            var request = isDeactivatedList ? userService.activate : userService.deactivate;
            var load = Promise.all(selectedEmployees.map(function (user) {
                return request(user).then(function () {
                    return userService.get(user.uuid).then(function (updatedUser) { return handleActivationStatusChange(_this.props.variables, updatedUser); });
                });
            })).then(onSave);
            _this.setState({ load: load });
            return load;
        };
        return _this;
    }
    ManageUsersBottomBar.prototype.render = function () {
        var _this = this;
        var _a = this.props, selectedEmployees = _a.selectedEmployees, formatMessage = _a.formatMessage;
        var load = this.state.load;
        var employeesLength = selectedEmployees.length;
        var isDeactivatedList = this.isDeactivatedList();
        return (React.createElement(PopUp, null,
            React.createElement(Grid, null,
                React.createElement(Flex, { alignItems: "baseline", paddingTop: 2, paddingBottom: 2 },
                    React.createElement(H3, null,
                        React.createElement(FormattedMessage, { id: "admin.components.manageUsersPopUp.header", values: { employeesLength: employeesLength } })),
                    React.createElement(Button, { destructive: true, onClick: this.openDeactivatePopUp, marginLeft: 2 }, isDeactivatedList ? (React.createElement(FormattedMessage, { id: "admin.components.manageUsersPopUp.button.activate" })) : (React.createElement(FormattedMessage, { id: "admin.components.manageUsersPopUp.button.deactivate" })))),
                React.createElement(AreYouSurePopUp, { ref: function (c) {
                        _this.deactivatePopup = c;
                    }, load: load, text: this.areYouSureText(), buttonText: isDeactivatedList
                        ? formatMessage({ id: "admin.components.manageUsersPopUp.button.buttonText.activate" })
                        : formatMessage({ id: "admin.components.manageUsersPopUp.button.buttonText.deactivate" }), onSubmit: this.handleSubmit }))));
    };
    ManageUsersBottomBar.defaultProps = {
        employeesLength: 0
    };
    return ManageUsersBottomBar;
}(Component));
export default injectIntl(ManageUsersBottomBar, { withRef: true });
